const Conditional = ({ if: ifCondiction, children }) =>
  ifCondiction && children;

export default Conditional;
